import {
  MainDynamicFormComponent
} from './components/dynamic-forms-components/main-dynamic-form/main-dynamic-form.component';
import {ReplacePipe} from './pipes/replace.pipe';
import {SearchPipe} from './pipes/search.pipe';
import {SafeResourcePipe} from './pipes/safe-resource-pipe';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {PageTitleComponent} from './components/page-title/page-title.component';
import {ModalHeaderComponent} from './components/modal-header/modal-header.component';
import {MaterialModule} from '../material.module';
import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgApexchartsModule} from 'ng-apexcharts';
import {ViewAttachmentComponent} from './components/pdf-viewer/view-attachment/view-attachment.component';
import {CustomPdfViewerComponent} from './components/pdf-viewer/custom-pdf-viewer/custom-pdf-viewer.component';
import {SidebarComponent} from './components/layout/sidebar/sidebar.component';
import {SystemLayoutComponent} from './components/layout/system-layout/system-layout.component';
import {DataTableComponent} from './components/tables/data-table/data-table.component';
import {TableComponent} from './components/tables/table/table.component';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {ContentComponent} from './components/layout/content/content.component';
import {StepIndicatorComponent} from './components/step-indicator/step-indicator.component';
import {AttachmentComponent} from './components/dynamic-forms-components/attachment/attachment.component';
import {ButtonComponent} from './components/dynamic-forms-components/button/button.component';
import {CheckboxComponent} from './components/dynamic-forms-components/checkbox/checkbox.component';
import {DateComponent} from './components/dynamic-forms-components/date/date.component';
import {DynamicFieldDirective} from './components/dynamic-forms-components/dynamic-field/dynamic-field.directive';
import {InputComponent} from './components/dynamic-forms-components/input/input.component';
import {RadiobuttonComponent} from './components/dynamic-forms-components/radiobutton/radiobutton.component';
import {SelectComponent} from './components/dynamic-forms-components/select/select.component';
import {TextareaComponent} from './components/dynamic-forms-components/textarea/textarea.component';
import {MatSelectSearchComponent} from './components/mat-select-search/mat-select-search.component';
import {PaginationButtonsComponent} from './components/tables/pagination-buttons/pagination-buttons.component';
import {DataTableHybridComponent} from './components/tables/data-table-hybrid/data-table-hybrid.component';
import {AttachmentListComponent} from './components/attachment-list/attachment-list.component';
import {RemoveUnderscorePipe} from './pipes/remove-underscore.pipe';
import {TruncatePipe} from './pipes/truncate.pipe';
import {FormatDatePipe} from './pipes/format-date.pipe';
import {MultiColumnsComponent} from './components/multi-columns/multi-columns.component';
import {FormatNumberPipe} from './pipes/format-number.pipe';
import {NumberToWordPipe} from './pipes/number-to-word.pipe';
import {UserByIdPipe} from './pipes/user-by-id.pipe';
import {RoundPipe} from './pipes/round.pipe';
import {QRCodeModule} from 'angularx-qrcode';
import {FormatAttachmentGroupPipe} from './pipes/format-attachment-group.pipe';
import {AllDetailsComponentComponent} from './all-details-component/all-details-component.component';
import {HeaderComponent} from './components/header/header.component';
import {HighchartsChartModule} from 'highcharts-angular';
import {ContentMenuComponent} from './components/layout/content-menu/content-menu.component';
import {LandingComponent} from './components/outer-layouts/landing/landing.component';
import {NgxMatTimelineModule} from 'ngx-mat-timeline';
import {DashboardHeaderComponent} from './components/dashboard-header/dashboard-header.component';
import {DashboardChartComponent} from './components/highcharts/dashboard-chart/dashboard-chart.component';
import {PdfViewerUrlComponent} from './components/pdf-viewer/pdf-viewer-url/pdf-viewer-url.component';
import {
  FullscreenViewAttachmentComponent
} from './components/pdf-viewer/fullscreen-view-attachment/fullscreen-view-attachment.component';
import {FooterComponent} from './components/layout/footer/footer.component';
import {BottomSheetHeaderComponent} from './components/bottom-sheet-header/bottom-sheet-header.component';
import {TranslateModule} from '@ngx-translate/core';
import {AttachmentDragDropComponent} from './components/attachment-drag-drop/attachment-drag-drop.component';
import {FileUploadModule} from 'ng2-file-upload';
import {ImagePickerComponent} from './components/image-picker/image-picker.component';
import {CarouselComponent} from './components/carousel/carousel.component';
import {PaginatorComponent} from '../modules/shared/components/paginator/paginator.component';
import {AccordionComponent} from './components/accordion/accordion.component';
import {SharedAccordionComponent} from './components/shared-accordion/shared-accordion.component';
import {CompanyRegistrationComponent} from '../guest/register/company-registration/company-registration.component';
import {
  ForeignerRegistrationComponent
} from '../guest/register/foreigner-registration/foreigner-registration.component';
import {NgxMaskDirective, NgxMaskPipe} from 'ngx-mask';
import {ChipComponent} from "./components/dynamic-forms-components/chip/chip.component";
import {DynamicFormsImportExport} from "./components/dynamic-forms-components/dynamic-forms-import-export";
import {QuillEditorComponent} from "ngx-quill";
import {CdkFixedSizeVirtualScroll} from "@angular/cdk/scrolling";
import {SearchSelectComponent} from "./components/search-select/search-select.component";
// import {
//   ServiceItemComponent
// } from "../guest/portal/citizens/portal-service-searches/shared-portal-services-list/service-item/service-item.component";
// import {
//   SharedPortalServicesListComponent
// } from "../guest/portal/citizens/portal-service-searches/shared-portal-services-list/shared-portal-services-list.component";
// import {CitizenHeaderComponent} from "../guest/portal/citizens/citizen-header/citizen-header.component";
import {PortalFooterComponent} from "../guest/portal/portal-footer/portal-footer.component";
import {PortalTitleBarComponent} from "../guest/portal/portal-title-bar/portal-title-bar.component";
import {FormatPricePipe} from "./pipes/format-price.pipe";
import {
  TgsdClientRequestedServicesListComponent
} from '../guest/portal/tgsd-client-requested-services-list/tgsd-client-requested-services-list.component';
import {SafeHtmlPipe} from "./pipes/safe-html.pipe";
import {
  RequestDetailsComponent
} from "../guest/portal/tgsd-client-requested-services-list/request-details/request-details.component";
import {TgsdClientFeedbackComponent} from "../guest/portal/tgsd-client-feedback/tgsd-client-feedback.component";
import {
  FeedbackFollowUpComponent
} from "../guest/portal/tgsd-client-feedback/feedback-follow-up/feedback-follow-up.component";
import {
  ServiceItemComponent
} from "../guest/portal/citizens/portal-service-searches/shared-portal-services-list/service-item/service-item.component";
import {
  SharedPortalServicesListComponent
} from "../guest/portal/citizens/portal-service-searches/shared-portal-services-list/shared-portal-services-list.component";
import {CitizenHeaderComponent} from "../guest/portal/citizens/citizen-header/citizen-header.component";
import {FeedbackWindowComponent} from "./components/feedback-window/feedback-window.component";
import {
  CitizenServicesDeliveryProcedureStepsComponent
} from "./components/citizen-services-delivery-procedure-steps/citizen-services-delivery-procedure-steps.component";
import {TrackNumberPopupComponent} from './components/feedback-window/track-number-popup/track-number-popup.component';
import {AttachmentViewComponent} from "../guest/portal/tgsd-client-feedback/attachment-view/attachment-view.component";
import {
  CitizenRegistrationComponent
} from "../guest/register/citizen/citizen-registration/citizen-registration.component";
import {OtpVerificationComponent} from "../guest/register/citizen/otp-verification/otp-verification.component";
import {ForgetPasswordComponent} from "../guest/forget-password/forget-password.component";
import {ImageCropperComponent} from "ngx-image-cropper";
import {VerifyPhoneComponent} from "../guest/forget-password/verify-phone/verify-phone.component";
import {PasswordResetComponent} from "../guest/forget-password/password-reset/password-reset.component";
import {
  SessionTimeoutWarnDialogComponent
} from "./components/session-timeout-warn-dialog/session-timeout-warn-dialog.component";
import {FontAwesomeIconComponent} from "./components/font-awesome-icon/font-awesome-icon.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ViewDetailsItemComponent} from "./components/view-details-item/view-details-item.component";
import {TabLayoutComponent} from "./components/tab-layout/tab-layout.component";
import {ValueCheckerPipe} from "./pipes/value-checker.pipe";
import {AttachmentChipComponent} from "./components/attachment-chip/attachment-chip.component";
import {LanguagePipe} from "./pipes/language.pipe";
import {TgsdViewDetailsItemComponent} from "./components/tgsd-view-details-item/tgsd-view-details-item.component";
import {EllipsisPipe} from "./pipes/ellipsis.pipe";
import {ConcatPipe} from "./pipes/concat.pipe";
import {FlowChartComponent} from "./components/flow-chart/flow-chart.component";
import {FFlowModule} from "@foblex/flow";
import {DesignationListComponent} from "./components/designation/designation-list/designation-list.component";
import {AddDesignationComponent} from "./components/designation/add-designation/add-designation.component";
import {
  AddApprovalSettingsComponent
} from "./components/approval-flow/approval-flow-settings-list/add-approval-settings/add-approval-settings.component";
import {
  ApprovalFlowSettingsListComponent
} from "./components/approval-flow/approval-flow-settings-list/approval-flow-settings-list.component";
import {
  ApprovalFlowStagesListComponent
} from "./components/approval-flow/approval-flow-stages/approval-flow-stages-list/approval-flow-stages-list.component";
import {
  AddApprovalFlowStagesListComponent
} from "./components/approval-flow/approval-flow-stages/add-approval-flow-stages-list/add-approval-flow-stages-list.component";
import {
  AddApprovalFlowSuccessorComponent
} from './components/approval-flow/approval-flow-successor/add-approval-flow-successor/add-approval-flow-successor.component';
import {AuditTrailComponent} from "./components/audit-trail/audit-trail.component";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {UpdatePublicServantComponent} from "./components/update-public-servant/update-public-servant.component";
import {GuestCarouselComponent} from "../guest/guest-carousel/guest-carousel.component";
import {GuestAuthMainLayoutComponent} from "../guest/guest-auth-main-layout/guest-auth-main-layout.component";
import {CopyRightsComponent} from "../guest/copy-rights/copy-rights.component";
import {
  ServiceStatisticsBannerComponent
} from "../guest/portal/citizens/services-new-searches/service-statistics-banner/service-statistics-banner.component";
import {
  ServiceFilterBannerComponent
} from "../guest/portal/citizens/services-new-searches/service-filter-banner/service-filter-banner.component";
import {
  HudumaTgsdComponent
} from "../guest/portal/citizens/citizen-header/top-nav-pages/huduma-tgsd/huduma-tgsd.component";
import {
  DharuraTgsdComponent
} from "../guest/portal/citizens/citizen-header/top-nav-pages/dharura-tgsd/dharura-tgsd.component";
import {FaqTgsdComponent} from "../guest/portal/citizens/citizen-header/top-nav-pages/faq-tgsd/faq-tgsd.component";
import {FaqGeneralPageComponent} from "../guest/portal/citizens/faq-general-page/faq-general-page.component";
import {HelpUtilityComponent} from "../guest/portal/help-utility/help-utility.component";
import {
  AboutTgsdComponent
} from "../guest/portal/citizens/citizen-header/top-nav-pages/about-tgsd/about-tgsd.component";
import {SetNewPasswordComponent} from "../guest/forget-password/set-new-password/set-new-password.component";
import {
  MrejeshoSearchTgsdComponent
} from "../guest/portal/citizens/citizen-header/top-nav-pages/mrejesho-search-tgsd/mrejesho-search-tgsd.component";
import {ScrollAnimateDirective} from "./directives/scroll-animation.directive";
import {SequentialAnimateDirective} from "./directives/sequential-animate.directive";
import {
  PortalStaticSitesComponent
} from "../guest/portal/portal-home/portal-static-sites/portal-static-sites.component";
import {
  PortalNewsAndSlidesComponent
} from "../guest/portal/portal-home/portal-news-and-slides/portal-news-and-slides.component";
import {
  PortalFlipCarouselComponent
} from "../guest/portal/portal-home/portal-flip-carousel/portal-flip-carousel.component";
import {TypewriterTextComponent} from "../guest/portal/portal-home/typewriter-text/typewriter-text.component";
import {
  PortalServiceSearchComponent
} from "../guest/portal/portal-home/portal-service-search/portal-service-search.component";
import {
  PortalInstitutionSearchComponent
} from "../guest/portal/portal-home/portal-institution-search/portal-institution-search.component";
import {ContrastComponent} from "./components/accessibility-components/contrast.component";
import {AccessibilityComponent} from './components/accessibility-components/accessibility/accessibility.component';
import {InvertComponent} from "./components/accessibility-components/invert.component";
import {LineHeightComponent} from "./components/accessibility-components/line-height.component";
import {SaturateComponent} from "./components/accessibility-components/saturate.component";
import {ScreenMaskComponent} from "./components/accessibility-components/screen-mask.component";
import {ScreenReaderComponent} from "./components/accessibility-components/screen-reader.component";
import {TextSizeComponent} from "./components/accessibility-components/text-size.component";
import {TextSpacingComponent} from "./components/accessibility-components/text-spacing.component";
import {TextAlignComponent} from "./components/accessibility-components/text-align.component";
import {PauseAnimationsComponent} from "./components/accessibility-components/pause-animations.component";
import {HighlightLinksComponent} from "./components/accessibility-components/highlight.component";
import {HideImagesComponent} from "./components/accessibility-components/hide-images.component";
import {DyslexiaFriendlyComponent} from "./components/accessibility-components/dyslexia-friendly.component";
import {
  PortalPopularServicesViewComponent
} from "../guest/portal/portal-home/portal-popular-services-view/portal-popular-services-view.component";
import {
  PortalPopularServicesViewDetailsComponent
} from "../guest/portal/portal-home/portal-popular-services-view/portal-popular-services-view-details/portal-popular-services-view-details.component";


const sharedComponents = [
  PortalStaticSitesComponent,
  PortalNewsAndSlidesComponent,
  PortalPopularServicesViewComponent,
  PortalPopularServicesViewDetailsComponent,
  PortalFlipCarouselComponent,
  TypewriterTextComponent,
  PortalServiceSearchComponent,
  PortalInstitutionSearchComponent
];

@NgModule({


  declarations: [
    DataTableComponent,
    DataTableHybridComponent,
    // TablePageableComponent,
    PaginationButtonsComponent,
    ModalHeaderComponent,
    PageTitleComponent,
    StepIndicatorComponent,
    SafeResourcePipe,
    ValueCheckerPipe,
    ReplacePipe,
    SafeHtmlPipe,
    InputComponent,
    ChipComponent,
    ButtonComponent,
    SelectComponent,
    AttachmentComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    TextareaComponent,
    DynamicFieldDirective,
    MatSelectSearchComponent,
    AttachmentListComponent,
    SidebarComponent,
    ContentComponent,
    SpinnerComponent,
    SystemLayoutComponent,
    SearchPipe,
    TableComponent,
    TgsdViewDetailsItemComponent,
    ViewAttachmentComponent,
    CustomPdfViewerComponent,
    MainDynamicFormComponent,
    RemoveUnderscorePipe,
    TruncatePipe,
    RoundPipe,
    FormatDatePipe,
    MultiColumnsComponent,
    FormatNumberPipe,
    NumberToWordPipe,
    UserByIdPipe,
    FormatAttachmentGroupPipe,
    AllDetailsComponentComponent,
    HeaderComponent,
    ContentMenuComponent,
    LandingComponent,
    DashboardHeaderComponent,
    DashboardChartComponent,
    PdfViewerUrlComponent,
    FullscreenViewAttachmentComponent,
    FooterComponent,
    BottomSheetHeaderComponent,
    AttachmentDragDropComponent,
    ImagePickerComponent,
    CarouselComponent,
    PaginatorComponent,
    AccordionComponent,
    CompanyRegistrationComponent,
    CitizenRegistrationComponent,
    ForeignerRegistrationComponent,
    SharedAccordionComponent,
    SearchSelectComponent,
    FlowChartComponent,
    ...DynamicFormsImportExport,
    ServiceItemComponent,
    SharedPortalServicesListComponent,
    CitizenHeaderComponent,
    PortalFooterComponent,
    PortalTitleBarComponent,
    FormatPricePipe,
    EllipsisPipe,
    FontAwesomeIconComponent,
    ViewDetailsItemComponent,
    TabLayoutComponent,
    AttachmentChipComponent,
    TgsdClientRequestedServicesListComponent,
    RequestDetailsComponent,
    TgsdClientFeedbackComponent,
    FeedbackFollowUpComponent,
    FeedbackWindowComponent,
    CitizenServicesDeliveryProcedureStepsComponent,
    TrackNumberPopupComponent,
    AttachmentViewComponent,
    OtpVerificationComponent,
    ForgetPasswordComponent,
    SetNewPasswordComponent,
    VerifyPhoneComponent,
    PasswordResetComponent,
    SessionTimeoutWarnDialogComponent,
    LanguagePipe,
    DesignationListComponent,
    AddDesignationComponent,
    ApprovalFlowSettingsListComponent,
    AddApprovalSettingsComponent,
    ApprovalFlowStagesListComponent,
    AddApprovalFlowStagesListComponent,
    AddApprovalFlowSuccessorComponent,
    AuditTrailComponent,
    UpdatePublicServantComponent,
    GuestCarouselComponent,
    GuestAuthMainLayoutComponent,
    CopyRightsComponent,
    ServiceStatisticsBannerComponent,
    ServiceFilterBannerComponent,
    HudumaTgsdComponent,
    DharuraTgsdComponent,
    FaqTgsdComponent,
    FaqGeneralPageComponent,
    HelpUtilityComponent,
    AboutTgsdComponent,
    MrejeshoSearchTgsdComponent,
    ScrollAnimateDirective,
    SequentialAnimateDirective,
    ...sharedComponents,
    AccessibilityComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    FontAwesomeModule,
    NgxPermissionsModule,
    NgApexchartsModule,
    NgxExtendedPdfViewerModule,
    QRCodeModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule,
    NgxMatTimelineModule,
    FileUploadModule,
    QuillEditorComponent,
    CdkFixedSizeVirtualScroll,
    NgOptimizedImage,
    ImageCropperComponent,
    ConcatPipe,
    FFlowModule,
    NgxIntlTelInputModule,
    ContrastComponent,
    InvertComponent,
    LineHeightComponent,
    SaturateComponent,
    ScreenMaskComponent,
    ScreenReaderComponent,
    TextSizeComponent,
    TextSpacingComponent,
    NgOptimizedImage,
    TextAlignComponent,
    PauseAnimationsComponent,
    HighlightLinksComponent,
    HideImagesComponent,
    DyslexiaFriendlyComponent
  ],
  exports: [
    HighchartsChartModule,
    DataTableComponent,
    DataTableHybridComponent,
    // TablePageableComponent,
    PaginationButtonsComponent,
    ModalHeaderComponent,
    PageTitleComponent,
    StepIndicatorComponent,
    DynamicFieldDirective,
    MainDynamicFormComponent,
    MatSelectSearchComponent,
    AttachmentListComponent,
    SidebarComponent,
    ContentComponent,
    LanguagePipe,
    SpinnerComponent,
    SystemLayoutComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPermissionsModule,
    MaterialModule,
    SafeResourcePipe,
    SearchPipe,
    ReplacePipe,
    EllipsisPipe,
    TgsdViewDetailsItemComponent,
    NgApexchartsModule,
    ViewAttachmentComponent,
    CustomPdfViewerComponent,
    TableComponent,
    MainDynamicFormComponent,
    RemoveUnderscorePipe,
    TruncatePipe,
    RoundPipe,
    FormatDatePipe,
    MultiColumnsComponent,
    FormatNumberPipe,
    NumberToWordPipe,
    UserByIdPipe,
    QRCodeModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FontAwesomeIconComponent,
    ViewDetailsItemComponent,
    TabLayoutComponent,
    FontAwesomeModule,
    ValueCheckerPipe,
    AttachmentChipComponent,
    // NgxPrintModule,
    FormatAttachmentGroupPipe,
    HeaderComponent,
    LandingComponent,
    DashboardHeaderComponent,
    DashboardChartComponent,
    AttachmentComponent,
    PdfViewerUrlComponent,
    FullscreenViewAttachmentComponent,
    BottomSheetHeaderComponent,
    AttachmentDragDropComponent,
    ImagePickerComponent,
    CarouselComponent,
    PaginatorComponent,
    SharedAccordionComponent,
    CompanyRegistrationComponent,
    ForeignerRegistrationComponent,
    CitizenRegistrationComponent,
    SearchSelectComponent,
    ...DynamicFormsImportExport,
    FlowChartComponent,
    ServiceItemComponent,
    SharedPortalServicesListComponent,
    CitizenHeaderComponent,
    PortalFooterComponent,
    PortalTitleBarComponent,
    FormatPricePipe,
    TgsdClientRequestedServicesListComponent,
    ConcatPipe,
    FeedbackWindowComponent,
    CitizenServicesDeliveryProcedureStepsComponent,
    OtpVerificationComponent,
    SessionTimeoutWarnDialogComponent,
    DesignationListComponent,
    AddDesignationComponent,
    ApprovalFlowSettingsListComponent,
    AddApprovalSettingsComponent,
    ApprovalFlowStagesListComponent,
    AddApprovalFlowStagesListComponent,
    AddApprovalFlowSuccessorComponent,
    AuditTrailComponent,
    GuestCarouselComponent,
    GuestAuthMainLayoutComponent,
    CopyRightsComponent,
    FooterComponent,
    ServiceStatisticsBannerComponent,
    ServiceFilterBannerComponent,
    HudumaTgsdComponent,
    DharuraTgsdComponent,
    FaqTgsdComponent,
    FaqGeneralPageComponent,
    HelpUtilityComponent,
    AboutTgsdComponent,
    MrejeshoSearchTgsdComponent,
    ScrollAnimateDirective,
    SequentialAnimateDirective,
    ...sharedComponents,
    NgOptimizedImage
  ],
})
export class SharedModule {
}
